import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  Create,
  useForm,
} from "@pankod/refine-antd";
import {  IHealthInsurer } from "interfaces";
import { HealthInsurerForm } from "components/forms";

export const HealthInsurerCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IHealthInsurer>();
  return (
    <Create saveButtonProps={saveButtonProps}>
      <HealthInsurerForm
        formProps={formProps}
        queryResult={queryResult}
      />
    </Create>
  );
};
